import * as React from "react";
import { forwardRef } from "react";
const SvgIcArrow24 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 25, height: 25, viewBox: "0 0 25 25", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "ic-arrow-24" }, /* @__PURE__ */ React.createElement("path", { id: "Vector", d: "M17.4393 13.0001L5 13.0001V11.5001L17.4394 11.5001L11.1893 5.25011L12.25 4.18945L19.7803 11.7198V12.7804L12.25 20.3108L11.1893 19.2501L17.4393 13.0001Z", fill: "currentColor" })));
const ForwardRef = forwardRef(SvgIcArrow24);
export { ForwardRef as ReactComponent };
